import React from 'react';
import { CommandCenter } from './components/CommandCenter';
export function App() {
  return <CommandCenter data-id="element-0" />;
}